import { Injectable, inject } from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';

import {catchError, concatMap, map} from 'rxjs/operators';
import {Store} from '@ngrx/store';
import {AppState} from './index';
import {ContentDbService} from '../services/content-db.service';
import {throwError} from 'rxjs';
import {ContentActions} from './action-types';
import {MessagesService} from '../shared/services/messages.service';
import {LoadingService} from '../shared/services/loading.service';


@Injectable({
  providedIn: 'root'
})
export class ContentEffects {
  private actions$ = inject(Actions);
  private store = inject<Store<AppState>>(Store);
  private content = inject(ContentDbService);
  private messages = inject(MessagesService);
  private loading = inject(LoadingService);


  loadSubscriptionContent$ =  this.createLoadContentEffect("subscription", ContentActions.getSubscriptionContent,ContentActions.subscriptionContentLoaded);

  saveSubscriptionContent$ = this.createSaveContentEffect("subscription", ContentActions.subscriptionContentUpdated);

  loadHomePageContent$ = this.createLoadContentEffect("home-page", ContentActions.getHomePageContent, ContentActions.homePageContentLoaded);

  saveHomePageContent$ = this.createSaveContentEffect("home-page", ContentActions.homePageContentUpdated);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {

  }


  createLoadContentEffect(contentPath:string, getContentAction: any, contentLoadedAction:any) {
    return  createEffect(() => this.actions$
      .pipe(
        ofType(getContentAction),
        concatMap(() => this.loading.showLoaderUntilCompleted(this.content.loadPageContent(contentPath))),
        map((content) => contentLoadedAction({content})),
        catchError(err => {
          this.messages.error('Could not load content in path:' + contentPath);
          return throwError(err);
        })
      ));
  }

  createSaveContentEffect(saveContentPath:string, updateContentAction: any) {
    return createEffect(() => this.actions$
      .pipe(
        ofType(updateContentAction),
        concatMap((action:any) => this.content.savePageContent(saveContentPath, action.content)),
        catchError(err => {
          this.messages.error('Could not save content in path:' + saveContentPath);
          return throwError(err);
        })
      ),
      {dispatch:false});
  }



}
